import { useState } from "react";
import api from "../lib/api";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/login", { username, password });
      localStorage.setItem("dtile_admin_token", data.token);
      toast.success(`Welcome, ${data.username}`);
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1E2C5A] px-6" data-testid="admin-login">
      <div className="absolute top-6 left-6 md:top-10 md:left-10 text-white/60 text-xs uppercase tracking-[0.25em]">
        TileRoom · Command Center
      </div>
      <div className="max-w-md w-full bg-[#FAF9F6] p-10 md:p-14 relative">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-[#C9A968] flex items-center justify-center">
          <Lock className="w-5 h-5 text-[#1E2C5A]" strokeWidth={2} />
        </div>
        <p className="label-eyebrow mt-4">Restricted Access</p>
        <h1 className="font-editorial text-4xl mt-3 mb-1">Admin Sign In</h1>
        <p className="text-sm text-[#5C5C5C] mb-10">
          Enter your credentials to access product management, orders, dashboard and referrals.
        </p>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="label-eyebrow block mb-1">Username</label>
            <input
              className="input-editorial"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              data-testid="admin-username"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-1">Password</label>
            <input
              className="input-editorial"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="admin-password"
              autoComplete="current-password"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-clay w-full" data-testid="admin-login-submit">
            {busy ? "Signing in..." : "Sign In"} <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </form>
      </div>
    </div>
  );
}
